import { useMutation } from "react-query";
import { showErrorToast } from "~/components/Toast";
import i18n from "~/i18n";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";

export const useRunReport = (onErrorCallback) => {
  return useMutation({
    mutationFn: (data) => {
      const query = encodeData(data);
      return fetch({
        url: `${Angie.api_url}/reports/run?${query}`,
        method: "GET",
      });
    },
    onError: () => {
      if (typeof onErrorCallback === "function") onErrorCallback();
      showErrorToast(i18n.t("Unable to run report."));
    },
  });
};
